var map = {
	"./1.png": "vldV",
	"./10.png": "h797",
	"./100.png": "HFfy",
	"./11.png": "De4H",
	"./12.png": "TNPK",
	"./13.png": "dvkY",
	"./14.png": "GXGQ",
	"./15.png": "s0Is",
	"./16.png": "32d3",
	"./17.png": "gToh",
	"./18.png": "x0MF",
	"./19.png": "LmGJ",
	"./2.png": "ZRrR",
	"./20.png": "JOR0",
	"./200.png": "viA6",
	"./201.png": "zUDj",
	"./202.png": "zfPk",
	"./203.png": "9Kks",
	"./204.png": "4FnT",
	"./205.png": "GGJP",
	"./206.png": "YOVc",
	"./207.png": "7DU4",
	"./21.png": "q1Nr",
	"./22.png": "n1ky",
	"./23.png": "JLEL",
	"./24.png": "wgkT",
	"./3.png": "SSL0",
	"./4.png": "W/Qi",
	"./5.png": "Ok/j",
	"./6.png": "ukEr",
	"./7.png": "WJC8",
	"./8.png": "xzYi",
	"./9.png": "GdQV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "U2tm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish ^\.\/.*\.png$
// module id = U2tm
// module chunks = 0